import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../Navbar";
import { getData } from "../../../services/library";
import { logEventos } from "../../../services/services";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Button,
  Container,
  ListItemIcon,
  MenuItem,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { Autorenew } from "@mui/icons-material";
import HistoryIcon from "@mui/icons-material/History";
import AltaPrecioCategoria from "./alta/AltaPrecioCategoria";
import EdicionPrecioCategoria from "./edicion/EdicionPrecioCategoria";
import ActualizarPreciosCategorias from "./actualizacion/ActualizarPreciosCategorias";
import HistorialPreciosCategorias from "./historial/HistorialPreciosCategorias";

function PreciosCategorias() {
  const [lista, setLista] = useState([]);
  const [tabla, setTabla] = useState(true);
  const [alta, setAlta] = useState(false);
  const [editar, setEditar] = useState(false);
  const [actualizarMasivo, setActualizarMasivo] = useState(false);
  const [verHistorial, setVerHistorial] = useState(false);
  const [dataRow, setDataRow] = useState({});

  const obtenerPrecios = () => {
    const sucursales = localStorage.getItem("suc_auth"); // string tipo "1,2,3"
    getData(`/envasado_rango_categorias/sucauth/${sucursales}`, setLista);
  };

  useEffect(() => {
    obtenerPrecios();
  }, []);

  useEffect(() => {
    logEventos(
      "tabla de rango de precios por categoria",
      "Envasado",
      "rango de precios por sucursal, producto y tipo de cliente",
      localStorage.getItem("user")
    );
  }, []);

  const handleClickNuevo = () => setAlta(true);

  const handleCloseAlta = () => {
    setAlta(false);
    obtenerPrecios();
  };

  const handleCloseEditar = () => {
    setEditar(false);
    obtenerPrecios();
  };

  const handleCloseActualizarMasivo = () => {
    setActualizarMasivo(false);
    obtenerPrecios();
  };

  const handleVerHistorial = () => {
    setTabla(false);
    setVerHistorial(true);
  };

  const handleCloseHistorial = () => {
    setVerHistorial(false);
    setTabla(true);
  };

  const columns = useMemo(
    () => [
      { header: "Sucursal", accessorKey: "nombre_sucursal", size: 100 },
      { header: "Producto", accessorKey: "nombre_producto", size: 100 },
      { header: "Tipo de Cliente", accessorKey: "nombre_tipocliente", size: 100 },
      { header: "Precio Mínimo", accessorKey: "precio_minimo", size: 100 },
      { header: "Precio Máximo", accessorKey: "precio_maximo", size: 100 },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex",
    expand: "Ex",
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 10 },
    grouping: ["nombre_sucursal", "nombre_tipocliente"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  return (
    <>
      {tabla && (
        <>
          <Navbar />
          <Container maxWidth="xl" sx={{ my: 1 }} disableGutters>
            <MaterialReactTable
              columns={columns}
              data={lista ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false}
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableRowActions={true}
              enableGrouping={true}
              enablePinning={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
              localization={customLocalization}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              positionToolbarAlertBanner="none"
              muiTableDetailPanelProps={{
                sx: {
                  backgroundColor: "white",
                  width: "100%",
                },
              }}
              enableColumnResizing={true}
              muiTableBodyCellProps={() => ({
                align: "left",
              })}
              renderTopToolbarCustomActions={() => (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxTwoToneIcon />}
                    onClick={handleClickNuevo}
                  >
                    Nuevo Rango
                  </Button>
                  <Typography variant="poster" fontSize={26}>
                    Rango de Precios por Categoría
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Autorenew />}
                    onClick={() => setActualizarMasivo(true)}
                  >
                    Actualizar Precios
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<HistoryIcon />}
                    onClick={handleVerHistorial}
                  >
                    Historial
                  </Button>
                </>
              )}
              renderRowActionMenuItems={({ closeMenu, row }) => [
                <MenuItem
                  key={0}
                  sx={{ m: 0 }}
                  onClick={() => {
                    setDataRow(row.original);
                    setEditar(true);
                    closeMenu();
                  }}
                >
                  <ListItemIcon>
                    <Autorenew color="primary" />
                  </ListItemIcon>
                  Actualizar precio
                </MenuItem>,
              ]}
            />
          </Container>
        </>
      )}

      {verHistorial && (
        <HistorialPreciosCategorias onClose={handleCloseHistorial} />
      )}

      {alta && (
        <AltaPrecioCategoria open={alta} onClose={handleCloseAlta} lista={lista} />
      )}
      {editar && (
        <EdicionPrecioCategoria
          open={editar}
          onClose={handleCloseEditar}
          row={dataRow}
        />
      )}
      {actualizarMasivo && (
        <ActualizarPreciosCategorias
          open={actualizarMasivo}
          onClose={handleCloseActualizarMasivo}
          lista={lista}
        />
      )}
    </>
  );
}

export default PreciosCategorias;
